angular.module('impactx.account').filter('ibanToAccNo', function ()
{
    /**
     * Formats a german IBAN to show only the account number portion.
     *
     * @param  {string} iban the IBAN to format
     * @return {string} the formatted IBAN, empty {string} if the IBAN does not have a german country code.
     */
    return function(iban)
    {
        iban = iban || '';
        var formattedIban = '';

        if (iban.length === 22 && iban.startsWith("DE"))
        {
            formattedIban = iban.substr(12);
            formattedIban = formattedIban.replace(/^0*/, "");
        }
        return formattedIban;
    };
});
